import React from 'react';
import Router from './routes/Router';
import './assets/scss/main.scss';
import 'bootstrap/dist/css/bootstrap.css';
import { SystemMessageProvider } from './contexts/SystemMessageContext';

function App() {
	return (
		<SystemMessageProvider>
			<React.Suspense>
				<Router />
			</React.Suspense>
		</SystemMessageProvider>
	);
}

export default App;
